var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    attrs: {
      model: _vm.form,
      "label-position": "left",
      "label-width": "150px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "邮件标题",
      required: ""
    }
  }, [_c("el-input", {
    staticStyle: {
      width: "300px"
    },
    attrs: {
      type: "input",
      placeholder: "字符长度不能超过10"
    },
    model: {
      value: _vm.form.email_title,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "email_title", $$v);
      },
      expression: "form.email_title"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "邮件内容",
      required: ""
    }
  }, [_c("el-input", {
    staticStyle: {
      width: "300px"
    },
    attrs: {
      type: "textarea",
      autosize: {
        minRows: 3,
        maxRows: 5
      },
      placeholder: "请输入内容"
    },
    model: {
      value: _vm.form.email_content,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "email_content", $$v);
      },
      expression: "form.email_content"
    }
  })], 1), _c("el-divider", {
    attrs: {
      "content-position": "left"
    }
  }), _c("el-form-item", {
    attrs: {
      label: "物品配置"
    }
  }, [_c("el-button", {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      type: "success",
      size: "mini"
    },
    on: {
      click: function click($event) {
        return _vm.addGoodsMsg();
      }
    }
  }, [_vm._v(" 添加一行物品配置 ")]), _vm._l(_vm.form.item_list, function (item, index) {
    return _c("div", {
      key: index,
      staticStyle: {
        display: "display: inline-block"
      }
    }, [_c("goods-options", {
      staticStyle: {
        float: "left"
      },
      attrs: {
        type: 2,
        goodsArray: _vm.goodsArray
      },
      model: {
        value: item.item_id,
        callback: function callback($$v) {
          _vm.$set(item, "item_id", $$v);
        },
        expression: "item.item_id"
      }
    }), _c("span", {
      staticStyle: {
        "margin-left": "10px"
      }
    }, [_vm._v("填写数量")]), _c("el-input", {
      staticStyle: {
        width: "80px",
        "margin-left": "10px"
      },
      attrs: {
        type: "number"
      },
      model: {
        value: item.num,
        callback: function callback($$v) {
          _vm.$set(item, "num", _vm._n($$v));
        },
        expression: "item.num"
      }
    }), _c("i", {
      staticClass: "el-icon-remove",
      staticStyle: {
        "font-size": "25px",
        "margin-left": "10px"
      },
      on: {
        click: function click($event) {
          return _vm.reduceGoodsMsg(index);
        }
      }
    }), _c("span", {
      staticStyle: {
        float: "right"
      }
    })], 1);
  })], 2), _c("el-divider", {
    attrs: {
      "content-position": "left"
    }
  }), _c("el-form-item", {
    attrs: {
      label: "定时发送"
    }
  }, [_c("el-switch", {
    attrs: {
      "active-value": 1,
      "inactive-value": 0
    },
    on: {
      change: function change($event) {
        return _vm.changeSwitch($event);
      }
    },
    model: {
      value: _vm.form.is_timing_send,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_timing_send", $$v);
      },
      expression: "form.is_timing_send"
    }
  }), _vm._v(" " + _vm._s(_vm.isTimeSend[_vm.form.is_timing_send]) + " "), _vm.form.is_timing_send == 1 ? _c("el-date-picker", {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      type: "datetime",
      placeholder: "选择日期时间",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: _vm.form.timing_send,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "timing_send", $$v);
      },
      expression: "form.timing_send"
    }
  }) : _vm._e()], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };